import script from "./BookmarkIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BookmarkIcon.vue?vue&type=script&setup=true&lang=js"

import "./BookmarkIcon.vue?vue&type=style&index=0&id=132b82ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132b82ab"]])

export default __exports__